module.exports = __webpack_public_path__ + "4e1a25e45f963b5997f4e457747440d8.jpg";